import { apiFetch } from '../../../shared/api/apiFetch'
import type { TeamMapLineDto, TeamMapLineWriteBody } from '../mapLineDtoMappers'

export type { TeamMapLineDto, TeamMapLineWriteBody }

interface ListTeamMapLinesResponse {
  items: TeamMapLineDto[]
}

// Collection root keeps the trailing slash because the .NET endpoints register
// the list/create routes as `MapGet("/")` / `MapPost("/")` inside a route group
// (`/clubhouse/teams/{teamId}/map-lines`), mirroring teamMapPinsApi.ts. Sub-paths
// (`/{lineId}`) are concatenated without an extra slash.
const base = (teamId: string) => `/clubhouse/teams/${encodeURIComponent(teamId)}/map-lines`

export async function listTeamMapLines(teamId: string, token: string): Promise<TeamMapLineDto[]> {
  const r = await apiFetch<ListTeamMapLinesResponse>(`${base(teamId)}/`, { token })
  return r.items
}

export async function createTeamMapLine(
  teamId: string,
  body: TeamMapLineWriteBody,
  token: string,
): Promise<TeamMapLineDto> {
  return apiFetch<TeamMapLineDto>(`${base(teamId)}/`, {
    method: 'POST',
    body: JSON.stringify(body),
    token,
  })
}

// Full replace, not a partial patch: unlike teamMapPinsApi's update, the .NET
// UpdateTeamMapLineRequest has no "leave unchanged" semantics for a missing
// field, so every TeamMapLineWriteBody field is required here too.
export async function updateTeamMapLine(
  teamId: string,
  lineId: string,
  body: TeamMapLineWriteBody,
  token: string,
): Promise<TeamMapLineDto> {
  return apiFetch<TeamMapLineDto>(`${base(teamId)}/${encodeURIComponent(lineId)}`, {
    method: 'PUT',
    body: JSON.stringify(body),
    token,
  })
}

export async function deleteTeamMapLine(teamId: string, lineId: string, token: string): Promise<void> {
  await apiFetch<undefined>(`${base(teamId)}/${encodeURIComponent(lineId)}`, {
    method: 'DELETE',
    token,
  })
}
